import React, { useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Send, Phone, MapPin, Instagram } from "lucide-react";

const IG = "https://www.instagram.com/svproduction6?stkn=MWZoMm5wc2lkcDk4bQ==";

export default function Contact() {
  const [c, setC] = useState({ name: "", email: "", phone: "", project_type: "", message: "" });

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", { ...c, requirement: c.project_type, company: "" });
      toast.success("Inquiry sent. Our team will reach out shortly.");
      setC({ name: "", email: "", phone: "", project_type: "", message: "" });
    } catch { toast.error("Could not send inquiry."); }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <section className="max-w-[1200px] mx-auto px-4 sm:px-8 lg:px-12 py-20 grid lg:grid-cols-2 gap-14 items-start">
        <div>
          <div className="sv-overline mb-4">Contact</div>
          <h1 className="font-serif-hero text-4xl lg:text-6xl text-[#F4EFE4]">Let's create<br />something.</h1>
          <p className="mt-6 text-[#CDC7BA] leading-relaxed max-w-md">For casting, production, model booking or partnership inquiries — reach the SV Talent team.</p>
          <div className="mt-10 space-y-4 text-sm text-[#CDC7BA]">
            <div className="flex items-center gap-3"><MapPin size={16} className="text-[#C5A059]" />Mohali, Punjab, India</div>
            <a href="tel:+918968681108" className="flex items-center gap-3 hover:text-[#F4E4BC] transition-colors"><Phone size={16} className="text-[#C5A059]" />89686 81108</a>
            <a href={IG} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-[#F4E4BC] transition-colors"><Instagram size={16} className="text-[#C5A059]" />@svproduction6</a>
          </div>
        </div>
        <form onSubmit={submit} className="sv-card p-8 grid gap-3">
          <div className="grid grid-cols-2 gap-3">
            <input required data-testid="contact-name" placeholder="Name" className="sv-input" value={c.name} onChange={(e) => setC({ ...c, name: e.target.value })} />
            <input required type="email" data-testid="contact-email" placeholder="Email" className="sv-input" value={c.email} onChange={(e) => setC({ ...c, email: e.target.value })} />
            <input data-testid="contact-phone" placeholder="Phone" className="sv-input" value={c.phone} onChange={(e) => setC({ ...c, phone: e.target.value })} />
            <select data-testid="contact-project" className="sv-select" value={c.project_type} onChange={(e) => setC({ ...c, project_type: e.target.value })}>
              <option value="">Project Type</option>
              {["Casting", "Music Video", "Film / OTT", "Fashion", "Advertising", "Editorial", "Brand Campaign", "Other"].map((o) => <option key={o}>{o}</option>)}
            </select>
          </div>
          <textarea required rows={5} data-testid="contact-message" placeholder="Message" className="sv-input" value={c.message} onChange={(e) => setC({ ...c, message: e.target.value })} />
          <button type="submit" data-testid="contact-send" className="sv-btn-primary inline-flex items-center gap-2 justify-center"><Send size={14} />Send Inquiry</button>
        </form>
      </section>
      <Footer />
    </div>
  );
}
